import { graphql } from "gatsby";

import Page, { Head as PageHead } from "./page";
// eslint-disable-next-line import/no-unused-modules
export default Page;

// eslint-disable-next-line import/no-unused-modules
export const workPageQuery = graphql`
  query WorkPage($id: String!) {
    graphCmsPage(id: { eq: $id }) {
      ...Page
    }
    site {
      buildYear: buildTime(formatString: "YYYY")
      buildTime(formatString: "dddd, MMMM DD YYYY, HH:mm:ss")
      siteMetadata {
        siteUrl
        siteName
        logo
        cookieName
      }
    }
  }
`;

// eslint-disable-next-line import/no-unused-modules
export const Head = PageHead;
